import { SkipLink } from './SkipLink/SkipLink';

document.addEventListener('DOMContentLoaded', () => {
	SkipLink.init();
});
